import * as React from 'react';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import {Button, ButtonGroup} from 'reactstrap';
import renderDatePickerField from '../../../../theme/components/form/DatePicker';
import Panel from '../../../../theme/components/Panel';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import validate from './validate';
import * as moment from 'moment';
import renderSelectField from '../../../../theme/components/form/Select';
import {FuerzasVenta} from '../../../../utils/constants';


class StockProductoForm extends React.PureComponent<InjectedFormProps> {

    private get fuerzaVentaOptions() {
        const options = [
            {value: '', label: 'Todos'},
            {value: FuerzasVenta.GLORIA.almacenId, label: FuerzasVenta.GLORIA.descripcion},
            {value: FuerzasVenta.SAN_FERNANDO.almacenId, label: FuerzasVenta.SAN_FERNANDO.descripcion},
            {value: FuerzasVenta.KIMBERLY.almacenId, label: FuerzasVenta.KIMBERLY.descripcion},
            {value: FuerzasVenta.NEXO.almacenId, label: FuerzasVenta.NEXO.descripcion},
            {value: FuerzasVenta.STANLEY.almacenId, label: FuerzasVenta.STANLEY.descripcion},
            {value: FuerzasVenta.AUREN2.almacenId, label: FuerzasVenta.AUREN2.descripcion}
        ];
        return options;
    }

    public render() {
        const {handleSubmit} = this.props;

        return (
            <Panel xs={12} md={12} divider={true} title='Filtros'>
                <form className='form' onSubmit={handleSubmit}>
                    <div className='form__form-group'>
                        <label className='form__form-group-label'>Fecha</label>
                        <div className='form__form-group-field'>
                            <Field
                                name='fecha'
                                component={renderDatePickerField}
                                filterDate={(date) => {
                                    return moment() > date;
                                }}
                                defaultDate={moment()}
                                placeholder='dd/mm/yyyy'
                            />
                            <div className='form__form-group-icon'>
                                <CalendarBlankIcon/>
                            </div>
                        </div>
                    </div>
                    <div className='form__form-group'>
                        <label className='form__form-group-label'>Fuerza de Venta </label>
                        <div className='form__form-group-field'>
                            <Field
                                name='fuerzaVenta'
                                component={renderSelectField}
                                placeholder='Todos'
                                type='text'
                                options={this.fuerzaVentaOptions}
                            />
                        </div>
                    </div>
                    <ButtonGroup className='btn-group--justified'>
                        <Button color='success' type='submit'>FILTRAR</Button>
                    </ButtonGroup>
                </form>
            </Panel>
        )
    }
}

export default reduxForm({
    form: 'stock_producto_form', // a unique identifier for this form
    validate,
})(StockProductoForm);



// WEBPACK FOOTER //
// ./src/components/pages/stock/producto/stock-producto-form.tsx